var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canRedFlush(_vm.record))?_c('el-button',{staticClass:"red-flush-button",attrs:{"type":"text","size":"small","loading":_vm.busy},on:{"click":_vm.redFlush}},[_vm._v(" 红冲 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }